<div id="hotelbooking" class="registration container">
  <form #hotelbookingForm="ngForm" [ngClass]="{'form-complete': hotelbookingForm.valid}" name="hotelbookingForm" (ngSubmit)="forward(hotelbookingForm)" novalidate autocomplete="off" appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.HOTEL.heading' | copy | async }}</h1>

    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.label' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <mat-radio-group [(ngModel)]="hotelneeded.Value" name="hotelNeeded" #hotelNeeded="ngModel" required (ngModelChange)="clearRequests()">
          <mat-radio-button value="Y" >Yes</mat-radio-button>
          <mat-radio-button value="N" >No</mat-radio-button>
          <mat-radio-button value="R" *ngIf="attendee.PAXTypeNo!==8" >My roommate has already requested our hotel accommodations.</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation  [object]="hotelNeeded" isRequired=true ></app-validation></mat-error>
          </div>
        </mat-radio-group>
        <div class="w-100 standout-box" [innerHTML]='"copy.html.hotelmapinfo" | copy | async'></div>
      </article>
    </section>
    <section class="card" *ngIf="hotelneeded.Value === 'Y'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.hotels' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <div>{{ 'copy.label.HOTEL.hotelinstruction' | copy | async }}</div>
        <div class="error ng-invalid" *ngFor="let error of getNonContiguousHotels()">
          <strong><span class="fas fa-stack"><i class="fas fa-exclamation fa-stack-1x"></i><i class="fas fa-circle-thin fa-stack-2x"></i></span> Rooms selected not contiguous for {{error}}. </strong>
        </div>
        <div class="error ng-invalid" [hidden]="!noHotel">
          <strong><span class="fas fa-stack"><i class="fas fa-exclamation fa-stack-1x"></i><i class="fas fa-circle-thin fa-stack-2x"></i></span>Please select at least one hotel room.</strong>
        </div>
        <div class="table-responsive w-100">
          <table class="table hotelTable" *ngIf="hotelList != undefined">
            <thead>
              <tr>
              <th></th>
              <th *ngIf="this.preextend > 0" class="preextension-b extension-header" [attr.colspan]="preextend">Pre Extension</th>
              <th *ngIf="this.groupDays > 0" class="eventDates-b" [attr.colspan]="groupDays + 1">Event Dates</th>
              <th *ngIf="this.postextend > 0" class="postextension-b extension-header" [attr.colspan]="postextend">Post Extension</th>
              </tr>
            </thead>

            <tbody *ngFor="let hotelobj of hotelList.roomTypeList">
              <tr>
                <th rowspan="2" class="hotelDetails"><h2>{{hotelobj.supplierName}}</h2>
                  <!-- <a class="desktopDetails" ng-if="!hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.showdetails"|copy|async}}</a>
                  <a class="desktopDetails" ng-if="hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.hidedetails"|copy|async}}</a> -->
                  <p><a class="mobileDetails" (click)="showModal(hotelobj)">{{"copy.label.HOTEL.BOOKING.mobiledetails"|copy|async}}</a></p>
                </th>
                <th class="custom-cell-date-b" *ngFor="let n of dateRange"><span class="day">{{n|date:"EEE": "-0500"}}</span><span class="date">{{n| date:"MMM d": "-0500"}}</span></th>
              </tr>
              <tr>
                <!-- <td></td> -->
                <td *ngFor="let n of hotelobj.roomNightsListWithRate" [ngClass]="{'prepost-c': n.groupDateFlag!=='GRP'}">
                  <div class="d-flex justify-content-center flex-column align-items-center" *ngIf="isHotelAvailableOnDate(hotelobj, n.blockDate) && !n.isBookedAsPending" [ngClass]="{'not-available': !isHotelAvailableOnDate(hotelobj, n.blockDate)}">
                    <!-- <input type="checkbox" [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" (click)="addNight(n.blockDate, hotelobj.webHotelGroupID)"> -->
                    <mat-checkbox style="position: relative; z-index: 100;"  
                    [disabled] = "pickedHotel !== undefined && pickedHotel != hotelobj.webHotelGroupID "
                    [unchecked] = "unchecked()"
                    [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" 
                    (change)="addNight(n.blockDate, hotelobj.webHotelGroupID)">

                </mat-checkbox>
                    <div class="hotel_desc" *ngIf="n.nightNetRate !== 0">{{n.nightNetRate| currency}} </div>
                    <div class="hotel_desc" *ngIf="n.netRateAltText">{{n.netRateAltText}} </div>
                  </div>
                  <div class="d-flex justify-content-center flex-column align-items-center" *ngIf="isHotelAvailableOnDate(hotelobj, n.blockDate) && n.isBookedAsPending">
                    <!-- <input type="checkbox" [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" (click)="addNight(n.blockDate, hotelobj.webHotelGroupID)"> -->
                    <mat-checkbox style="position: relative; z-index: 100;" 
                    [disabled] = "(pickedHotel !== undefined && pickedHotel != hotelobj.webHotelGroupID)"
                    [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" 
                    (change)="addNight(n.blockDate, hotelobj.webHotelGroupID)">

                </mat-checkbox>
                    
                    <div class="hotel_desc" *ngIf="n.nightNetRate !== 0">{{n.nightNetRate| currency}} </div>
                    <div class="hotel_desc" *ngIf="n.netRateAltText">{{n.netRateAltText}} </div>
                  </div>
                  <div class="d-flex justify-content-center flex-column align-items-center" *ngIf="!isHotelAvailableOnDate(hotelobj, n.blockDate)" [ngClass]="{'not-available': !isHotelAvailableOnDate(hotelobj, n.blockDate)}">
                    <span class="material-icons">
                      clear
                    </span>
                    <div class="hotel_desc">{{"copy.label.HOTEL.BOOKING.notavail"|copy|async}} </div>
                  </div>
                </td>
              </tr>
              <!-- <tr>&nbsp;&nbsp;</tr> -->
            </tbody>
          </table>
        </div>
      </article>
    </section>
    <section class="card" *ngIf="hotelneeded.Value === 'Y'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.roominfo' | copy | async }}
        </div>
      </div>
      <article>
        <div class="card-body w-100">
          <div class="d-flex justify-content-start w-100" [innerHTML]='"copy.html.hotelPrefText" | copy | async'></div>
          <mat-form-field class="prefixInput">
            <mat-label for="beddingPref">{{ 'copy.label.HOTEL.roompref' | copy | async }}</mat-label>
            <mat-select name="beddingPref" id="beddingPref" aria-label="beddingPref" [(ngModel)]="bedding.Value"
              #beddingPref="ngModel" matNativeControl>
              <mat-option *ngFor="let obj of bedTypes" [value]="obj">{{ obj }}</mat-option>
            </mat-select>
            <mat-error><app-validation [object]="beddingPref"></app-validation></mat-error>
          </mat-form-field>
          <div class="d-flex justify-content-start w-100">
            <mat-form-field class="w-100">
              <mat-label class="w-100" for="hotelSpecialRequests" aria-labelledby="hotelSpecialRequests">{{
                'copy.label.HOTEL.special' |copy |async}}</mat-label>
              <textarea matInput class="w-100" name="hotelSpecialRequests" #hotelSpecialRequests="ngModel"[(ngModel)]="enrollment.HotelSpecialRequests"
                maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*"></textarea>
                <mat-error><app-validation [object]="hotelSpecialRequests" pattern="alphanum"></app-validation></mat-error>

            </mat-form-field>
          </div>
          <div *ngIf="attendee.PAXTypeNo!=8">{{'copy.html.roomsharetext' |copy |async}}<i class="fas fa-asterisk required" style="font-size: .4rem; vertical-align: super"></i></div>
          
        <div *ngIf="attendee.PAXTypeNo!=8" class="d-flex justify-content-start w-100">
          <!-- <mat-label for="bookingRoommate">{{ 'copy.label.ROOMMATE.bookingRoommate' | copy | async }}</mat-label>  -->
          <mat-radio-group [(ngModel)]="attendee.$mtcbookingRoommate" name="bookingRoommate" #bookingRoomate="ngModel" required>
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="d-flex justify-content-start w-100" *ngIf="attendee.$mtcbookingRoommate===true">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="roommateName" aria-labelledby="roommateName" required>{{
              'copy.label.ROOMMATE.roommateName' |copy |async}}</mat-label>
            <input matInput class="w-100" #roommatesName="ngModel" name="roommatesName"
              [(ngModel)]="roommate.Value" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*" required/>
            <mat-error><app-validation [object]="roommatesName" pattern="alpha" isRequired=true></app-validation></mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-start w-100" *ngIf="attendee.$mtcbookingRoommate===true">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="roommateEmail" aria-labelledby="roommateEmail">{{ 'copy.label.ROOMMATE.email'
              |copy |async}}</mat-label>
            <input matInput class="w-100" #roommatesEmail="ngModel" name="roommatesEmail"
              [(ngModel)]="roommateemail.Value" maxlength="225" pattern="[a-zA-Z0-9._'%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,125}[a-zA-Z]{2,63}"/>
            <mat-error><app-validation [object]="roommatesEmail"pattern="email"></app-validation></mat-error>
          </mat-form-field>
        </div>
        </div>
      </article>
    </section>
    <section class="card" *ngIf="hotelneeded.Value === 'R'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.roommateinfo' | copy | async }}
        </div>
      </div>
      <article>
        <div class="d-flex justify-content-start w-100" >
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="roommateName" aria-labelledby="roommateName" required>{{
              'copy.label.ROOMMATE.roommateName2' |copy |async}}</mat-label>
            <input matInput class="w-100" #roommatesName="ngModel" name="roommatesName"
              [(ngModel)]="roommate.Value" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*" required/>
            <mat-error><app-validation [object]="roommatesName" isRequired=true></app-validation></mat-error>
          </mat-form-field>
        </div>
        
        <div class="d-flex justify-content-start w-100">
          <mat-form-field class="w-100">
            <mat-label for="roommateArrivals">{{ 'copy.label.ROOMMATE.roommateArrival' | copy | async }}</mat-label>
            <mat-select #roomateArrivals="ngModel" name="roommateArrivals"
              id="roommateArrivals" aria-label="roommateArrivals" [(ngModel)]="roommatearrive.Value"
              #roommateArrivals="ngModel" matNativeControl required (ngModelChange)="setRoommateDates()">
              <mat-option *ngFor="let obj of arrivalDates" [value]="obj">{{ obj }}</mat-option>
            </mat-select>
            <mat-error><app-validation [object]="roommateArrivals" isRequired="true"></app-validation></mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-start w-100">
          <mat-form-field class="w-100">
            <mat-label for="roommateDepartures">{{ 'copy.label.ROOMMATE.roommateDeparture' | copy | async }}</mat-label>
            <mat-select name="roommateDepartures" id="roommateDepartures"
              aria-label="roommateDepartures" [(ngModel)]="roommatedepart.Value" #roommateDepartures="ngModel"
              matNativeControl required (ngModelChange)="setRoommateDates()">
              <mat-option *ngFor="let obj of departureDates" [value]="obj">{{ obj }}</mat-option>
            </mat-select>
            <mat-error><app-validation [object]="roommateDepartures"></app-validation></mat-error>
          </mat-form-field>
        </div>

      </article>
    </section>
    <section class="card" name="hotelFee" *ngIf="hotelneeded.Value === 'Y' || hotelneeded.Value === 'R'">
        <app-collect-payment cardType="Hotel"
        title="copy.label.PAYMENT.FEESRT10.hotelguarantee" [ccOnly]="true" additionaltext="copy.html.hotelguar"></app-collect-payment>
      <article>
        <div class="card-body w-100" *ngIf="CCerror"><mat-error >{{CCerror}}</mat-error></div>
      </article>
    </section>
    <section class="card" *ngIf="hotelneeded.Value === 'N'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.BOOKING.nohotellabel' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <mat-radio-group [(ngModel)]="enrollment.HotelSpecialRequests" name="noHotelReason" #noHotelReason="ngModel" required>
          <mat-radio-button *ngFor="let op of noHotelRadios" [value]="op.value">{{op.display}}</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation  [object]="noHotelReason" isRequired=true ></app-validation></mat-error>
          </div>
        </mat-radio-group>

        <mat-form-field class="w-100 required" *ngIf="enrollment.HotelSpecialRequests == 'Other'">
          <mat-label class="w-100 font-weight-bold" for="otherNoHotel"
            aria-labelledby="otherNoHotel">{{'copy.label.HOTEL.BOOKING.otherNoHotel'|copy|async}}</mat-label>
          <textarea matInput class="w-100" name="otherNoHotel" [(ngModel)]="otherNoHotel" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*" required></textarea>
        </mat-form-field>
      </article>
    </section>
    
    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
      </button>
      <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>
